const formatType = {
    simple: 0,
    csv: 1,
    entity: 2
};

export default [
    {id: formatType.simple, label: 'Simple'},
    {id: formatType.csv, label: 'CSV import'},
    {id: formatType.entity, label: 'Data entity'}
];

export {
    formatType
};